/**
 * Created by Qingger Corp.
 * User: yangzihua
 * Date: 2019/6/14
 * Time: 17:37
 * Desc: 云店设置-小程序配置
 */

import { Component, Vue } from 'vue-property-decorator';

// 子组件
import RealSite from '@/views/components/realSite/realSite.vue'; // 入驻网点
import AppBasicConfig from '@/views/components/appBasicConfig/appBasicConfig.vue'; // 基础配置
import GoodsCategoryBlackList from '@/views/components/goodsCategoryBlackList/goodsCategoryBlackList.vue'; // 商品分类黑名单
import AppDisplayConfig from '@/views/components/appDisplayConfig/appDisplayConfig.vue'; // 店铺页展示
import CategoryConfig from '@/views/components/categoryConfig/categoryConfig.vue'; // 分类配置
import PaymentConfig from '@/views/components/paymentConfig/paymentConfig.vue'; // 收款配置
import RecruitConfig from '@/views/components/recuitConfig/recuitConfig.vue'; // 入会配置
import StyleConfig from '@/views/components/styleConfig';
import NewDisplayConfig from '@/views/components/newDisplayConfig';
import NoAuth from '@/views/components/noAuth/noAuth.vue';
import MiniPage from '@/views/components/miniPage/miniBasePage';
import NewDistributionCofig from '@/views/components/newDistribution';
import ZonePrice from '@/views/components/zonePrice';

@Component({
  components: {
    RealSite,
    AppBasicConfig,
    CategoryConfig,
    AppDisplayConfig,
    GoodsCategoryBlackList,
    PaymentConfig,
    RecruitConfig,
    NoAuth,
    StyleConfig,
    NewDisplayConfig,
    MiniPage,
    NewDistributionCofig,
    ZonePrice,
  },
})
export default class AppConfig extends Vue {
  /* 数据 */

  /**
   * 当前页面的索引
   * @type {string}
   */
  public curPage = '1';

  /**
   * 页面名称
   * @type {ItemObject}
   */
  public pageNameObj: ItemObject = {
    p1: 'VSHOP-FUNCTION-BASIC-STORE-SITES', // 入驻网点
    p2: 'VSHOP-FUNCTION-BASIC-STORE-CONFIG', // 基础配置
    p3: 'VSHOP-FUNCTION-BASIC-STORE-CLASSES', // 分类配置
    p4: 'VSHOP-FUNCTION-BASIC-STORE-INDEX', // 店铺页展示
    p5: 'VSHOP-FUNCTION-BASIC-STORE-BLACKLIST', // 黑名单
    p6: 'VSHOP-FUNCTION-BASIC-STORE-PAY', // 收款配置
    p7: 'VSHOP-FUNCTION-BASIC-STORE-MEMBER', // 其他配置
    p10: 'VSHOP-FUNCTION-BASIC-STORE-SALES', // 分销策略
    p11: 'VSHOP-FUNCTION-BASIC-STORE-PARTATION', // 分区价格
  };

  /**
   * 内容是否显示
   * @type {boolean}
   */
  public isContentBodyShow = false;

  /**
   * 运营模式
   * 1 镜单  2 镜千 3 云单 4 云千
   * @type {string | number}
   */
  public operationMode = null;

  /* 方法 */

  /**
   * 切换页面
   */
  public onPageSwitch(key): void {
    this.curPage = key;
    this.setCurPageName(key); // 设置当前页索引到缓存
  }

  /**
   * 判断菜单权限
   * @param {string} name
   * @return {boolean}
   */
  public menuAuth(name: string): boolean {
    return this.$store.state.authMenuCodeList.includes(name);
  }

  /**
   * 获取当前页索引
   * @return null
   */
  public getNearCurPage(): void {
    // 找到最近的
    if (this.$store.state.authMenuCodeList.includes(this.pageNameObj.p7)) {
      this.curPage = '7';
      localStorage.setItem('curPageName', this.pageNameObj.p7);
    } else if (this.$store.state.authMenuCodeList.includes(this.pageNameObj.p1)) {
      this.curPage = '1';
      localStorage.setItem('curPageName', this.pageNameObj.p1);
    } else if (this.$store.state.authMenuCodeList.includes(this.pageNameObj.p10)) {
      this.curPage = '10';
      localStorage.setItem('curPageName', this.pageNameObj.p10);
    } else if (this.$store.state.authMenuCodeList.includes(this.pageNameObj.p11)) {
      this.curPage = '11';
      localStorage.setItem('curPageName', this.pageNameObj.p11);
    } else if (this.$store.state.authMenuCodeList.includes(this.pageNameObj.p3)) {
      this.curPage = '3';
      localStorage.setItem('curPageName', this.pageNameObj.p3);
    } else if (this.$store.state.authMenuCodeList.includes(this.pageNameObj.p4)) {
      this.curPage = '4';
      localStorage.setItem('curPageName', this.pageNameObj.p4);
    }
    //  else if (this.$store.state.authMenuCodeList.indexOf(this.pageNameObj.p5) > -1) {
    //   this.curPage = "5";
    //   localStorage.setItem("curPageName", this.pageNameObj.p5);
    // }
    // else if (this.$store.state.authMenuCodeList.indexOf(this.pageNameObj.p6) > -1) {
    //   this.curPage = "6";
    //   localStorage.setItem("curPageName", this.pageNameObj.p6);
    // }
    this.setCurPageName(this.curPage);
  }

  /**
   * 菜单名称和索引转换
   * @param {string} val
   * @return null
   */
  public getCurPage(val: string): void {
    switch (val) {
      case this.pageNameObj.p1:
        this.curPage = '1';
        break;
      case this.pageNameObj.p11:
        this.curPage = '11';
        break;
      case this.pageNameObj.p3:
        this.curPage = '3';
        break;
      case this.pageNameObj.p4:
        this.curPage = '4';
        break;
      // case this.pageNameObj.p5:
      //   this.curPage = "5";
      //   break;
      // case this.pageNameObj.p6:
      //   this.curPage = "6";
      //   break;
      case this.pageNameObj.p7:
        this.curPage = '7';
      case this.pageNameObj.p10:
        this.curPage = '10';
        break;
    }
  }

  /**
   * 设置当前页名称
   * @return null
   */
  public setCurPageName(key: string): void {
    // 设置缓存
    switch (key) {
      case '1':
        localStorage.setItem('curPageName', this.pageNameObj.p1);
        break;
      case '11':
        localStorage.setItem('curPageName', this.pageNameObj.p11);
        break;
      case '3':
        localStorage.setItem('curPageName', this.pageNameObj.p3);
        break;
      case '4':
        localStorage.setItem('curPageName', this.pageNameObj.p4);
        break;
      // case "5":
      //   localStorage.setItem("curPageName", this.pageNameObj.p5);
      //   break;
      // case "6":
      //   localStorage.setItem("curPageName", this.pageNameObj.p6);
      //   break;
      case '7':
        localStorage.setItem('curPageName', this.pageNameObj.p7);
      case '10':
        localStorage.setItem('curPageName', this.pageNameObj.p10);
        break;
    }
  }

  /**
   * 设置菜单权限
   * @return null
   */
  public menuAuthSet(): void {
    if (this.$route.params.curPage && this.pageNameObj[this.$route.params.curPage]) {
      this.getCurPage(this.pageNameObj[this.$route.params.curPage]);
    } else {
      this.getNearCurPage();
    }
  }

  /* 周期 */

  /**
   * 当组建创建时
   */
  public created() {
    // 获取运营模式
    this.operationMode = +this.$route.params.mode;
    // 权限检测
    this.isContentBodyShow = this.$store.state.authMenuCodeList.includes('VSHOP-FUNCTION-BASIC-STORE');
    if (this.isContentBodyShow) {
      this.menuAuthSet();
    }
  }
}
